<template>
  <div class="app-container">
    <base-header v-if="showType" activeIndex="0" />

    <div :class="showType ? 'banner__layer' :'banner__layer bannerss'">

      <img class="banner-img" src="@/assets/imgs/about/banner.png" />
      <img class="banner-imgs" src="@/assets/imgs/about/wap/banner.png" />

      <div :class="showType ? 'banner-content content-box' :'banner-content content-box banner-co'">
        <h1 class="title">稳健企业 焕发新生</h1>
        <h1 class="titles">稳健企业 </h1>
        <h1 class="titles"> 焕发新生</h1>
        <p class="banner-content-intro">香港黄金交易所AA类行员（081号）</p>
        <div class="banner-content-download">
          <router-link to="/Appdownload?key=1">
            <span class="banner-content-download-btn">APP下载</span>
          </router-link>
          <div class="banner-content-download-text">
            <div>
              <img src="@/assets/imgs/about/mobie-icon.png" alt="">
              <span>
                支持多平台 <br/>
                双端互通
              </span>
            </div>
            <div>
              <img src="@/assets/imgs/about/user-black-icon.png" alt="">
              <span>
                简单 <br/>
                易用
              </span>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="about-intro content-box">
      <img class="introimg" src="@/assets/imgs/about/trophy.png" alt="">
      <div class="about-intro-titles">
          <h1>关于<span>{{ $store.state.common.appName }}</span></h1>
          <p>金融牌照编号 ：NO.081</p>
        </div>
      <img class="introimgs" src="@/assets/imgs/about/wap/trophy.png" alt="">
      <div class="about-intro-right">
        <div class="about-intro-right-title">
          <h1>关于<span>{{ $store.state.common.appName }}</span></h1>
          <p>香港黄金交易所AA类081号行员 · 一站式贵金属交易平台</p>
        </div>
        <div class="about-intro-right-text">
          <span>{{ $store.state.common.appName }}</span>
          是红狮金业有限公司推出的优秀贵金属交易平台，平台成立于2010年，是香港黄金交易所AA类081号行员，且始终严格遵从香港金融监管的相关法规与行业规范，凭借过硬的资质与专业的运营，16年来稳定服务超百万用户。
        </div>
        <div class="about-intro-right-text">
          <span>{{ $store.state.common.appName }}作为集开户、交易于一体的一站式贵金属投资平台，</span>
          面向全球客户提供伦敦金、伦敦银交易产品，为客户提供全面的资讯服务，独到的行情走势分析，重要经济播报和专业在线咨询等，全方位满足投资者的需求。我们始终将客户利益放在首位，公司采用全球领先的MT4、MT5交易平台，坚持公开透明、公平公正的交易原则，并免费提供交易编码，同时，我们高度关注每一位客户的交易体验，通过严密的风控体系保障资金与数据安全，立志成为全球投资者长久信赖的贵金属交易服务平台。
        </div>
      </div>
    </div>

    <!-- 平台资质公示 -->
    <div class="about-qualification">
      <div class="qualification-header">
        <h2><span>平台</span>资质公示</h2>
        <p>合法持牌经营，所有资质信息向监管机构及公众公开披露，可官方渠道核实</p>
      </div>
      <div class="qualification-banner content-box">
        <div class="qualification-banner-left">
          <img src="@/assets/imgs/about/guarantee.png" alt="" class="guarantee-icon">
          <div class="qualification-banner-info">
            <p class="banner-name">香港黄金交易所 —— 行员名单官方查询</p>
            <p class="banner-sub">可在香港黄金交易所官网核实红狮金业有限公司 AA 类行员资质（编号 NO.081），信息实时公开</p>
            <a href="https://hkgx.com.hk/hk/member/memberlist" class="qualification-banner-btn" target="_blank">前往官方查询 →</a>
          </div>
        </div>
      </div>
      <div class="qualification-list content-box">
        <div class="qualification-item">
          <div class="qualification-img-wrap">
            <img src="@/assets/imgs/about/qualification1.png" alt="">
          </div>
          <div>
            <h3>香港黄金交易所<span>81号行员证书</span></h3>
            <p>由香港黄金交易所颁发之AA类行员资格，授权经营现货黄金、白银及相关贵金属交易业务，受香港黄金交易所严格监管。</p>
            <div class="query-link"><span>√ 认证有效</span> · 可官方查询核实</div>
          </div>
        </div>
        <div class="qualification-item">
          <div class="qualification-img-wrap">
            <img src="@/assets/imgs/about/qualification2.png" alt="">
          </div>
          <div>
            <h3>香港黄金交易所<span>AA类营业牌照</span></h3>
            <p>依香港公司法正式注册成立，具备合法经营资格，受香港特区法律约束与保护，经营行为受严格监管。</p>
            <div class="query-link"><span>√ 认证有效</span> · 香港公司注册处登记</div>
          </div>
        </div>
        <div class="qualification-item">
          <div class="qualification-img-wrap">
            <img src="@/assets/imgs/about/qualification3.png" alt="">
          </div>
          <div>
            <h3>香港认证A类<span>贵金属交易商</span></h3>
            <p>严格遵循香港金融监管机构相关条例，定期接受监管审查，确保交易流程、资金管理、用户服务体系全程合规。</p>
            <div class="query-link"><span>√ 持续合规</span> · 定期监管审查</div>
          </div>

        </div>
      </div>
      <div class="qualification-notice content-box">
        <p><strong>合规承诺：</strong>红狮金业严格执行行业监管要求，规范交易流程、资金管理、用户服务体系，坚守合规运营底线，杜绝违规营销与虚假宣传。所有推广内容均通过合规审核，不含收益承诺或诱导性表述，保障每一位客户的合法权益。</p>
      </div>
    </div>

    <!-- 为什么选择红狮 -->
    <div class="about-advantage">
      <div class="advantage-header">
        <h2>为什么选择<span>红狮</span></h2>
        <p>六大核心优势，为每一位投资者打造安全稳健的交易体验</p>
      </div>
      <div class="advantage-list content-box">
        <div class="advantage-item">
          <img src="@/assets/imgs/about/advantage1.png" alt="">
          <div class="advantage-item-right">
            <h3>极低交易点差</h3>
            <p>持续优化交易成本结构，提供具有市场竞争力的交易点差，力求为客户呈现高性价比的交易条件。</p>
          </div>
        </div>
        <div class="advantage-item">
          <img src="@/assets/imgs/about/advantage2.png" alt="">
          <div class="advantage-item-right">
            <h3>顶级流动性</h3>
            <p>直连国际顶级流动性，享受机构级的交易体验，确保报价稳定高效、执行迅速。</p>
          </div>
        </div>
        <div class="advantage-item">
          <img src="@/assets/imgs/about/advantage3.png" alt="">
          <div class="advantage-item-right">
            <h3>资金安全管理</h3>
            <p>客户资金隔离存管，配备顶级风控体系，全方位落实资金安全管理标准，保障客户资产独立安全。</p>
          </div>
        </div>
        <div class="advantage-item">
          <img src="@/assets/imgs/about/advantage4.png" alt="">
          <div class="advantage-item-right">
            <h3>专业交易体验</h3>
            <p>支持MT4/MT5实时同步，高性能交易系统保障多终端无缝交易，一秒平仓与EA智能交易全面支持。</p>
          </div>
        </div>
        <div class="advantage-item">
          <img src="@/assets/imgs/about/advantage5.png" alt="">
          <div class="advantage-item-right">
            <h3>权威资质监管</h3>
            <p>香港黄金交易所AA类081号行员资质，严格遵从香港金融监管相关法规，资质信息公开透明可查。</p>
          </div>
        </div>
        <div class="advantage-item">
          <img src="@/assets/imgs/about/advantage6.png" alt="">
          <div class="advantage-item-right">
            <h3>全天候专业客服</h3>
            <p>7×24小时专业客服团队在线，全天候响应您的服务需求，中英文双语支持，快速解决各类问题。</p>
          </div>

        </div>
      </div>
    </div>

    <!-- 品牌实力介绍 -->
    <div class="about-introduction">
      <div class="introduction-content content-box">
        <h2 class="introduction-title"><span>品牌实力</span>介绍</h2>
        <p class="introduction-subtitle">16年专注贵金属交易，以成绩说话，以口碑赢得信任</p>
        <div class="introduction-stats">
          <div class="stat-item">
            <div class="stat-title">
              <div class="stat-number">1,000,000<span>+</span></div>
              <div class="stat-label">稳定服务用户</div>
            </div>
            <div class="stat-intro">16年稳定服务，持续扩大全球用户覆盖</div>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-item">
            <div class="stat-title">
              <div class="stat-number">16<span>年</span></div>
              <div class="stat-label">稳健运营历史</div>
            </div>
            <div class="stat-intro">自2010年起深耕贵金属交易领域</div>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-item">
            <div class="stat-title">
              <div class="stat-number">1,000<span>+日</span></div>
              <div class="stat-label">平台系统持续打磨</div>
            </div>
            <div class="stat-intro">顶尖技术团队精益求精</div>
          </div>
        </div>
        <p class="introduction-subtitle2">16年深耕贵金属，<span>稳健服务</span>超百万用户</p>
        <p class="introduction-subtitle3">
          16年深耕贵金属 <br> <span>稳健服务</span>超百万用户
        </p>
        <p class="introduction-desc">红狮金业16年来稳定服务超百万用户，积累成熟的贵金属交易服务与风险管控经验。自2010年深耕香港贵金属市场，历经多轮全球经济周期考验，以稳健运营能力赢得行业与用户的长期信任。</p>
        <div class="introduction-btns">
          <span class="intro-btn-primary" @click="toSign">开立账户</span>
          <router-link to="/product">
            <span class="intro-btn-secondary">了解更多</span>
          </router-link>
        </div>
      </div>
    </div>

    <div class="about-cooperate">
      <div class="title__layer">
        <h1><span>合作</span>媒体</h1>
        <p>金融界强强联手，共筑媒体新辉煌</p>
      </div>
      <img class="pcimg" src="@/assets/imgs/about/cooperate.png" alt="">
      <img class="wapimg" src="@/assets/imgs/about/wap/cooperate.png" alt="">
    </div>

    <base-footer v-if="showType" />
  </div>  
</template>

<script>
import BaseHeader from '@/component/base-header';
import BaseFooter from '@/component/base-footer';

export default {
  name: 'About',
  metaInfo: {
    title: '关于红狮金业,现货黄金开户平台,安全持牌贵金属交易平台',
    meta: [
      { name: 'keywords', content: '红狮金业,黄金白银交易平台,红狮金业资质,红狮金业牌照,正规贵金属平台资质' },
      { name: 'description', content: '“红狮金业官方资质公示，香港黄金交易所AA类081号行员，持有正规贵金属交易运营资质，企业信息公开可查，合规运营、权威可信。' }
    ]
  },
  components: {
    BaseHeader,
    BaseFooter,
  },
 
  
  data() {
    return {
      screenWidth: document.body.clientWidth,//实时屏幕宽度
      showType:true
    }
  },
  created() {

    if (this.$route.query.from) {
      this.showType=false

    };
  },
  mounted() {

  },
  methods: {
    toSign() {
      window.open('https://' + location.hostname + '/uc/signUp/real');
    }
  },
}
</script>
<style lang="less" scoped>
.app-container {
  background: #fafafa;

  .content-box {
    width: 1240px;
    margin: auto;
    box-sizing: border-box;
  }

  .banner__layer {
    position: relative;
    // padding-top: 80px;
    .banner-img {
      width: 100%;
      display: block;
    }
    .banner-imgs{
      display: none;
      width: 100%;
      height: auto;
    }
    .banner-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 11;
      color: #FFFFFF;
      .title{
        display: block;
      }
      .titles{
        display: none;
      }
      h1 {
        font-size: 68px;
        margin: 0;
      }
      &-intro {
        font-size: 18px;
      }
      &-download {
        display: flex;
        align-items: center;
        margin-top: 50px;

        &-btn {
          width: 198px;
          line-height: 56px;
          color: #FFFFFF;
          background: #FA2314;
          border-radius: 4px;
          margin-right: 10px;
          cursor: pointer;
          text-align: center;
          font-size: 20px;
          font-weight: 700;
          display: inline-block;
        }

        &-text {
          display: flex;
          align-items: center;

          >div {
            display: flex;
            align-items: center;
            color: #FFFFFF;
            padding: 4px 40px;

            &:first-child {
              border-right: 1px solid #0F0F11;
            }

            img {
              width: 38px;
              height: 38px;
              margin-right: 12px;
            }
          }
        }
      }
    }
  }

  .title__layer {
    text-align: center;
    padding: 70px 0 50px;
    display: block;
    h1 {
      font-size: 46px;
      margin: 0;
      color: #000;
      margin-bottom: 10px;
      span {
        color: #FA2314;
      }
    }
    p {
      color: #0F0F11;
      font-size: 18px;
    }
  }
  
  .about-intro {
    margin: 100px auto;
    display: flex;
    align-items: center;
    .introimg{
      display: block;
    }
    .introimgs{
      display: none;
    }
    >img {
    
      width: 452px;
      margin-right: 60px;
    }
    &-titles{
      display: none;
      h1 {
          font-size: 36px;
          margin: 0;
          color: #000;
          margin-bottom: 10px;
          span {
            color: #FA2314;
          }
        }
      p{
        font-size: 14px;
      }
    }
    &-right {
      padding: 26px;

      &-title {
       display: block;
        h1 {
          font-size: 46px;
          margin: 0;
          color: #000;
          margin-bottom: 10px;
          span {
            color: #FA2314;
          }
        }
      }
      &-text {
        color: #6d6d6d;
        margin-top: 50px;
        span {
          color: #FA2314;
        }
      }
    }

  }

  .about-qualification {
    padding-bottom: 60px;

    .qualification-header {
      text-align: center;
      padding: 10px 0 50px;

      h2 {
        font-size: 46px;
        margin: 0 0 10px;
        color: #000;
        span {
          color: #FA2314;
        }
      }

      p {
        color: #0F0F11;
        font-size: 18px;
        margin: 0;
      }
    }

    .qualification-banner {
      position: relative;
      display: flex;
      align-items: center;
      background: #0A0A0A;
      padding: 20px 30px;
      margin-bottom: 40px;
      box-sizing: border-box;

      &-left {
        display: flex;
        align-items: center;

        .guarantee-icon {
          width: 82px;
          height: 94px;
          margin-right: 20px;
          flex-shrink: 0;
        }

        .banner-name {
          color: #fff;
          font-size: 18px;
          font-weight: bold;
          margin: 0 0 10px;
        }
        .banner-sub {
          color: #999;
          font-size: 13px;
          margin: 0;
        }
      }

      &-btn {
        position: absolute;
        right: 30px;
        top: 50%;
        transform: translateY(-50%);
        background: #FA2314;
        color: #fff;
        padding: 12px 24px;
        border-radius: 20px;
        white-space: nowrap;
        text-decoration: none;
        font-size: 14px;
        cursor: pointer;
        flex-shrink: 0;
      }
    }

    .qualification-list {
      display: flex;
      justify-content: space-between;
      gap: 24px;
      margin-top: 9%;

      .qualification-item {
        flex: 1;
        text-align: center;
        background: #fff;
        padding: 0 26px 30px;

        .qualification-img-wrap {
          img {
            width: 50%;
            display: block;
            margin: -33% auto 0;
          }
        }

        h3 {
          font-size: 18px;
          color: #333;
          margin: 20px 0 12px;
          line-height: 1.6;

          span {
            color: #FA2314;
          }
        }

        p {
          font-size: 16px;
          color: #93939F;
          line-height: 1.8;
          margin: 0;
        }

        .query-link {
          display: inline-block;
          margin-top: 12px;
          color: #93939F;
          font-size: 14px;
          cursor: pointer;

          span {
            color: #11C771;
          }
        }
      }
    }

    .qualification-notice {
      margin-top: 30px;
      background: rgba(250, 35, 20, 0.1);
      padding: 16px 20px;
      box-sizing: border-box;

      p {
        color: #FA2314;
        font-size: 13px;
        line-height: 1.8;
        margin: 0;
      }
    }
  }

  .about-advantage {
    padding-bottom: 80px;

    .advantage-header {
      text-align: center;
      padding: 30px 0 50px;

      h2 {
        font-size: 46px;
        margin: 0 0 10px;
        color: #000;

        span {
          color: #FA2314;
        }
      }

      p {
        color: #0F0F11;
        font-size: 18px;
        margin: 0;
      }
    }

    .advantage-list {
      display: flex;
      flex-wrap: wrap;
      gap: 28px;

      .advantage-item {
        width: calc(33.333% - 19px);
        background: #fff;
        padding: 30px;
        border-radius: 8px;
        box-sizing: border-box;
        display: flex;
        align-items: center;

        &-right {
          margin-left: 20px;
        }

        img {
          width: 90px;
          height: 90px;
          display: block;
        }

        h3 {
          font-size: 18px;
          color: #333;
          margin: 0 0 12px;
          font-weight: bold;
        }

        p {
          font-size: 14px;
          color: #93939F;
          line-height: 1.8;
          margin: 0;
        }
      }
    }
  }

  .about-introduction {
    background-image: url('../assets/imgs/about/introduction-bg.png');
    background-size: cover;
    background-position: center;
    padding: 80px 0;
    text-align: center;
    color: #ffffff;

    .introduction-title {
      font-size: 46px;
      margin: 0 0 16px;
      font-weight: bold;
      span {
        color: #FA2314;
      }
    }

    .introduction-subtitle {
      color: #fff;
      font-size: 18px;
      margin: 0 0 60px;
    }

    .introduction-stats {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 50px;

      .stat-item {
        padding: 0 60px;

        .stat-number {
          color: #fff;
          font-size: 48px;
          font-weight: bold;
          line-height: 1;

          span {
            font-size: 28px;
          }
        }

        .stat-label {
          font-size: 18px;
          margin: 10px 0 10px;
        }

        .stat-intro {
          color: #93939F;
          font-size: 16px;
        }
      }

      .stat-divider {
        width: 1px;
        height: 80px;
        background: rgba(255, 255, 255, 0.3);
        flex-shrink: 0;
      }
    }

    .introduction-subtitle2, .introduction-subtitle3 {
      font-size: 26px;
      margin-bottom: 10px;
      font-weight: 600;

      span {
        color: #FA2314;
      }
    }

    .introduction-subtitle3 {
      display: none;
    }

    .introduction-desc {
      max-width: 860px;
      color: #93939F;
      font-size: 18px;
      margin: 0 auto 60px;
    }

    .introduction-btns {
      display: flex;
      justify-content: center;
      gap: 26px;

      .intro-btn-primary {
        display: inline-block;
        background: #FA2314;
        color: #fff;
        padding: 15px 60px;
        border-radius: 30px;
        font-size: 20px;
        cursor: pointer;
      }

      .intro-btn-secondary {
        display: inline-block;
        background: transparent;
        color: #fff;
        border: 1px solid #fff;
        padding: 14px 60px;
        border-radius: 30px;
        font-size: 20px;
        cursor: pointer;
      }
    }
  }

  .about-cooperate {
    background: #FFFFFF;
    padding-bottom: 100px;
    text-align: center;
    .pcimg{
      display: block;
      margin: 0 auto;
    }
    .wapimg{
      display: none;
    }
    >img {
      width: 1132px;
    }
  }
}
@media screen and (max-width: 500px) {
  .app-container{
    .banner__layer{
      padding-top: 45px;
        .banner-img{
          display: none;
        }
        .banner-imgs{
          display: block;
          height: 500px;
       
        }
      
      .banner-content {
      position: absolute;
      top: 37%;
      left: 50%;
      padding-top: 40px;
      transform: translate(-50%, -50%);
      z-index: 11;
      // color: #000;
      color: #FFFFFF;
      background: linear-gradient(180deg, #100005 68.28%, rgba(24, 24, 24, 0) 100%);

       .title{
        display: none;
      }
      .titles{
        color: #FFFFFF;
        display: block;
      }
      h1 {
        font-size: 58px;
        line-height: 77px;
        margin: 0;
        width: 100%;
        text-align: center;
        white-space: wrap;
      }
      &-intro {
        font-size: 14px;
        text-align: center;
      }
      &-download {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 20px;

        &-btn {
          width: 180px;
          line-height: 34px;
          color: #FFFFFF;
          background: #FA2314;
          border-radius: 4px;
          margin-right: 10px;
          cursor: pointer;
          text-align: center;
          font-size: 14px;
          font-weight: 700;
          margin-bottom: 20px;
        }

        &-text {
          display: flex;
          align-items: center;

          >div {
            display: flex;
            align-items: center;
            color: #0F0F11;
          color: #FFFFFF;

            padding: 2px 20px;
            font-size: 10px;
            &:first-child {
              border-right: 1px solid #fff;
            }

            img {
              width: 24px;
              height: 24px;
              margin-right: 12px;
            }
          }
        }
      }
    }
    .banner-co{
      top: 33%;
    }
    }
    .bannerss{
      padding-top: 0;
    }
    .content-box {
      width: 100%;
      margin: auto;
      box-sizing: border-box;
    }
    .title__layer {
      display: none;
      .title{
        display: none;
      }
      .titles{
        display: block;
      }
      h1{
        font-size: 36px;
        line-height: 48px;
      }
      p{
        font-size: 14px;
      }
    }
    .about-intro{
      display: flex;
      flex-direction: column;

      &-titles{
        display: block;
        text-align: center;
        padding-top: 40px;
      }
       &-right {
         &-title {
          display: none;
         }
         &-text{
          font-size: 14px;
          color: #93939F;
          margin-top: 30px;
         }
       }
      .introimg{
          display: none;
       }
      .introimgs{
        display: block;
        width: 80%;
        height: auto;
        margin-right: 0;
        margin-top: 20px;
      }
    }
    .about-qualification {
      padding-bottom: 0px;

      .qualification-header {
        padding: 40px 20px 30px;
        h2 { font-size: 36px; }
        p { font-size: 14px; }
      }
      .qualification-banner {
        flex-direction: column;
        gap: 16px;
        padding: 16px;
        margin: 0 0 20px;
        &-left {
          .guarantee-icon { width: 56px; height: 64px; margin-right: 16px; }
          .banner-name { font-size: 14px; }
        }
        &-btn {
            display: inline-block;
            position: static;
            transform: none;
            margin-top: 12px;
            padding: 6px 14px;
            font-size: 12px;
            border-radius: 14px;
          }
      }
      .qualification-list {
        flex-direction: column;
        gap: 20px;
        padding: 0 20px;

        .qualification-item {
          display: flex;
          flex-direction: row-reverse;
          text-align: left;
          padding: 0 0 0 12px;

          h3 {
            font-size: 14px;
          }

          p, .query-link {
            font-size: 12px;
            line-height: 1.3;
          }

          .qualification-img-wrap {
            img {
              margin: 0 0 0 20px;
              width: 120px;
            }
          }
        }
      }
      .qualification-notice {
        margin: 10px 0 0;
        background: none;
        p { font-size: 12px; }
      }
    }
    .about-advantage {
      padding-bottom: 60px;
      .advantage-header {
        padding: 40px 20px 30px;
        h2 { font-size: 36px; }
        p { font-size: 14px; }
      }
      .advantage-list {
        flex-direction: column;
        gap: 12px;
        padding: 0 20px;
        .advantage-item {
          width: 100%;
          padding: 20px;

          .advantage-item-right {
            h3 {
              font-size: 14px;
            }
            p {
              font-size: 12px;
            }
          }
        }
      }
    }
    .about-introduction {
      background-image: url('../assets/imgs/about/wap/introduction-bg.png');
      padding: 50px 30px;
      .introduction-title { font-size: 36px; }
      .introduction-subtitle { font-size: 14px; margin-bottom: 36px; }
      .introduction-stats {
        text-align: left;
        flex-direction: column;
        gap: 0;
        margin-bottom: 30px;

        .stat-divider { display: none; }
        .stat-title {
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .stat-item {
          padding: 10px 0;
          width: 100%;
          border-bottom: 1px solid #C9C9CF66;

          .stat-number { font-size: 26px; }

          .stat-label {
            font-size: 14px;
          }

          .stat-intro {
            font-size: 12px;
          }
        }
      }
      .introduction-subtitle2 {
        display: none;
      }
      .introduction-subtitle3 {
        font-size: 24px;
        display: block;
      }
      .introduction-desc { 
        font-size: 13px;
        margin-bottom: 30px;
      }
      .introduction-btns {
        gap: 16px;
        .intro-btn-primary, .intro-btn-secondary {
          padding: 6px 22px;
          font-size: 14px;
        }
        .intro-btn-primary {
          padding: 8px 22px;
        }
      }
    }
    
    .about-cooperate {
      .pcimg{
        display: none;
      }
      .wapimg{
        display: block;
        width: 100%;
        margin: 0 auto;
      }
    }
  }
}
  // -------------------------小屏幕适配-------------------
  @media screen and (min-width: 1264px) and (max-width: 1724px) {
    .app-container {
        background: #fafafa;
    
        .content-box {
          width: 1000px;
          margin: auto;
          box-sizing: border-box;
        }
    
        .banner__layer {
          position: relative;
          // padding-top: 80px;
    
          .banner-img {
            width: 100%;
            display: block;
          }
    
          .banner-imgs {
            display: none;
            width: 100%;
            height: auto;
          }
    
          .banner-content {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 11;
            color: #FFFFFF;
    
            .title {
              display: block;
            }
    
            .titles {
              display: none;
            }
    
            h1 {
              font-size: 50px;
              margin: 0;
            }
    
            &-intro {
              font-size: 18px;
            }
    
            &-download {
              display: flex;
              align-items: center;
              margin-top: 50px;
    
              &-btn {
                width: 198px;
                line-height: 56px;
                color: #FFFFFF;
                background: #FA2314;
                border-radius: 4px;
                margin-right: 10px;
                cursor: pointer;
                text-align: center;
                font-size: 20px;
                font-weight: 700;
                display: inline-block;
              }
    
              &-text {
                display: flex;
                align-items: center;
    
                >div {
                  display: flex;
                  align-items: center;
                  color: #FFFFFF;
                  padding: 4px 40px;
    
                  &:first-child {
                    border-right: 1px solid #0F0F11;
                  }
    
                  img {
                    width: 38px;
                    height: 38px;
                    margin-right: 12px;
                  }
                }
              }
            }
          }
        }
    
        .title__layer {
          text-align: center;
          padding: 70px 0 50px;
          display: block;
    
          h1 {
            font-size: 46px;
            margin: 0;
            color: #000;
            margin-bottom: 10px;
    
            span {
              color: #FA2314;
            }
          }
    
          p {
            color: #0F0F11;
            font-size: 18px;
          }
        }
    
        .about-intro {
          margin: 100px auto;
          display: flex;
          align-items: center;
    
          .introimg {
            display: block;
          }
    
          .introimgs {
            display: none;
          }
    
          >img {
    
            width: 452px;
            margin-right: 60px;
          }
    
          &-titles {
            display: none;
    
            h1 {
              font-size: 36px;
              margin: 0;
              color: #000;
              margin-bottom: 10px;
    
              span {
                color: #FA2314;
              }
            }
    
            p {
              font-size: 14px;
            }
          }
    
          &-right {
            padding: 26px;
    
            &-title {
              display: block;
    
              h1 {
                font-size: 46px;
                margin: 0;
                color: #000;
                margin-bottom: 10px;
    
                span {
                  color: #FA2314;
                }
              }
            }
    
            &-text {
              color: #6d6d6d;
              margin-top: 50px;
    
              span {
                color: #FA2314;
              }
            }
          }
    
        }
    
        .about-advantage {
          .advantage-list {
            .advantage-item {
              width: calc(33.333% - 15px);
            }
          }
        }
        .about-introduction {
          .introduction-stats {
            .stat-item {
              padding: 0 40px;
              .stat-number { font-size: 38px; }
            }
          }
        }
    
        .about-cooperate {
          background: #FFFFFF;
          margin-top: 50px;
          padding-bottom: 100px;
          text-align: center;
    
          .pcimg {
            display: block;
            margin: 0 auto;
          }
    
          .wapimg {
            display: none;
          }
    
          >img {
            width: 1000px;
          }
        }
      }
  }
</style>